module.exports = __webpack_public_path__ + "static/media/AccountCircleBlack.5d5d7120.svg";